var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ipo-search',{staticClass:"py-2"}),(_vm.hasSelectedIpo)?_c('div',[_c('ipo-market-data'),_c('ipo-investment-schedule'),_c('ipo-investment-management'),_c('ipo-result-transfer'),_c('ipo-result-funds'),_c('ipo-result-accounts'),_c('ipo-result-funds-accounts'),_c('ipo-result-lockup')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }